// Entrar (com usuário e senha ou com a conta Microsoft) e trocar a senha (painel_rpa/web/entrar.html). Nesta página nenhum
// dado vira HTML: só textContent.
import { destinoSeguro } from "./comum/seguro.ts";

interface Resposta {
  ok: boolean;
  erro?: string;
  destino?: string;
  trocar_senha?: boolean;
  login?: boolean;
}

function el<T extends HTMLElement = HTMLElement>(sel: string): T {
  const e = document.querySelector<T>(sel);
  if (!e) throw new Error(`Elemento ${sel} não encontrado`);
  return e;
}
const campo = (sel: string): HTMLInputElement => el<HTMLInputElement>(sel);

async function post(url: string, corpo: object): Promise<Resposta> {
  const r = await fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(corpo), credentials: "same-origin" });
  try {
    return (await r.json()) as Resposta;
  } catch {
    return { ok: false, erro: `Resposta inesperada do servidor (${r.status}).` };
  }
}

function msg(alvo: HTMLElement, texto: string, tipo: "erro" | "ok" = "erro"): void {
  alvo.textContent = texto;
  alvo.className = "msg" + (texto ? " " + tipo : "");
}

const q = new URLSearchParams(location.search);

if (location.pathname === "/trocar-senha") {
  const form = el<HTMLFormElement>("#fTrocar");
  const aviso = el("#mTrocar");
  const botao = el<HTMLButtonElement>("#fTrocar .btn");
  form.hidden = false;
  campo("#atual").focus();
  const regras = (): void => {
    const nova = campo("#nova").value;
    const conf = campo("#conf").value;
    el('[data-r="tam"]').classList.toggle("ok", nova.length >= 10);
    el('[data-r="mix"]').classList.toggle("ok", /[A-Za-zÀ-ÿ]/.test(nova) && /\d/.test(nova));
    el('[data-r="igual"]').classList.toggle("ok", !!nova && nova === conf);
  };
  campo("#nova").addEventListener("input", regras);
  campo("#conf").addEventListener("input", regras);
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    if (campo("#nova").value !== campo("#conf").value) return msg(aviso, "As duas senhas novas não são iguais.");
    botao.disabled = true;
    try {
      const p = await post("/api/senha", { atual: campo("#atual").value, nova: campo("#nova").value });
      botao.disabled = false;
      if (p.ok) {
        msg(aviso, "Senha trocada. Abrindo a Torre…", "ok");
        setTimeout(() => { location.href = destinoSeguro(p.destino, location.origin) || "/"; }, 700);
      } else if (p.login) {
        location.href = "/login";
      } else {
        msg(aviso, p.erro || "Não deu para trocar a senha.");
      }
    } catch {
      botao.disabled = false;
      msg(aviso, "Sem conexão com o servidor da Torre.");
    }
  });
  el("#sair").addEventListener("click", () => {
    void post("/api/logout", {}).then(() => { location.href = "/login"; });
  });
} else {
  const form = el<HTMLFormElement>("#fEntrar");
  const aviso = el("#mEntrar");
  const botao = el<HTMLButtonElement>("#fEntrar .btn");
  // O servidor diz o modo em <body data-entrada>: "senha" (só usuário e senha), "microsoft" (o botão da Microsoft e a
  // senha) ou "so-microsoft" (a senha só para administradores). O botão só vem na página quando o login pela Microsoft está ligado.
  const modo = document.body.dataset["entrada"] ?? "senha";
  form.hidden = false;
  if (modo === "senha") {
    campo("#login").focus();
  } else {
    el("#subEntrar").textContent = modo === "so-microsoft"
      ? "Use a sua conta Microsoft de trabalho."
      : "Use a sua conta Microsoft de trabalho, ou o usuário e a senha que a Viaflow enviou para você.";
    // O botão e o "ou" vêm escondidos no HTML: um servidor sem o login pela Microsoft nunca os mostra
    el("#entrarMicrosoft").hidden = false;
    el("#ouSenha").hidden = false;
    const volta = destinoSeguro(q.get("volta"), location.origin);
    if (volta) el<HTMLAnchorElement>("#entrarMicrosoft").href = "/auth/microsoft?volta=" + encodeURIComponent(volta);
  }
  if (modo === "so-microsoft") {
    // Usuário e senha ficam para o acesso de emergência do Master: escondidos atrás de um link
    const mostrar = el<HTMLButtonElement>("#mostrarSenha");
    for (const s of ["#camposSenha", "#ouSenha", "#esqueceu"]) el(s).hidden = true;
    mostrar.hidden = false;
    mostrar.addEventListener("click", () => {
      mostrar.hidden = true;
      el("#camposSenha").hidden = false;
      campo("#login").focus();
    });
  }
  // A volta da Microsoft traz só um código (?erro=), nunca um texto: a mensagem é escolhida aqui
  const generico = "Não deu para entrar com a conta Microsoft. Tente de novo; se continuar, fale com um administrador da Torre.";
  const ERROS: ReadonlyMap<string, string> = new Map([
    ["microsoft", generico],
    ["microsoft-cancelado", "A entrada com a conta Microsoft foi cancelada ou não foi autorizada."],
    ["microsoft-conta", "A sua conta Microsoft não tem acesso à Torre. Peça a um administrador da Torre para liberar o seu e-mail."],
    ["microsoft-bloqueado", "Usuário bloqueado por 15 minutos depois de várias senhas erradas. Um Master pode desbloquear."],
    ["muitas", "Muitas tentativas deste endereço. Espere alguns minutos e tente de novo."],
  ]);
  const erro = q.get("erro");
  if (erro) msg(aviso, ERROS.get(erro) ?? generico);
  if (q.get("sem")) msg(aviso, "O seu perfil ainda não tem nenhum cliente liberado. Fale com um administrador da Torre.");
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    botao.disabled = true;
    msg(aviso, "");
    try {
      const p = await post("/api/login", { login: campo("#login").value.trim(), senha: campo("#senha").value });
      botao.disabled = false;
      if (!p.ok) {
        campo("#senha").value = "";
        campo("#senha").focus();
        return msg(aviso, p.erro || "Não deu para entrar.");
      }
      location.href = p.trocar_senha ? "/trocar-senha" : (destinoSeguro(q.get("volta"), location.origin) || destinoSeguro(p.destino, location.origin) || "/");
    } catch {
      botao.disabled = false;
      msg(aviso, "Sem conexão com o servidor da Torre.");
    }
  });
}
